(function () {
  'use strict';

  /* ── Currency formatting ─────────────────────────────────────────── */
  var activeCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

  function fmt(cents) {
    if (!cents) return '';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: activeCurrency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  /* ── Price pre-fetch ─────────────────────────────────────────────── */
  var priceCache = {};

  var PRICE_HANDLES = [
    'sundaeys-water-bottle-500-ml-add-on',
    'sundaeys-water-bottle-500ml',
    'the-standard',
    'the-supply',
    'sundaeys-powder',
    'capsules-duo',
    'capsules-trio',
    'the-pair',
  ];

  function prefetchPrices() {
    PRICE_HANDLES.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function (data) { priceCache[handle] = data.price; })
        .catch(function () {});
    });
  }

  /* ── Handle constants ──────────────────────────────────────────── */
  var H = {
    capsules:    'sundaeys-capsules',
    capsulesDuo: 'capsules-duo',
    capsulesTrio: 'capsules-trio',
    powder:      'sundaeys-powder',
    powderDuo:   'powder-duo',
    powderTrio:  'powder-trio',
    bottle:      'sundaeys-water-bottle-500ml',
    bottleAddon: 'sundaeys-water-bottle-500-ml-add-on',
    standard:    'the-standard',
    pair:        'the-pair',
    supply:      'the-supply',
    fullSet:     'the-full-set',
    cap:         'sundaeys-cap',
  };

  /* ── Sets for quick lookup ─────────────────────────────────────── */
  var SUPPRESS_ALL = new Set([H.supply, H.fullSet]);

  var SUPPLEMENTS = new Set([
    H.capsules, H.capsulesDuo, H.capsulesTrio,
    H.powder, H.powderDuo, H.powderTrio,
    H.standard, H.pair, H.supply, H.fullSet,
  ]);

  var POWDERS  = new Set([H.powder, H.powderDuo, H.powderTrio]);
  var BOTTLES  = new Set([H.bottle, H.bottleAddon]);

  /* ── Rules config — copy/prices computed dynamically where possible */
  var RULES = [
    /* Rule 1: Powder (any qty) in cart, no bottle → add bottle add-on */
    {
      id:       'powder-bottle',
      check:    function (handles) {
        return handles.some(function (h) { return POWDERS.has(h); }) &&
               !handles.some(function (h) { return BOTTLES.has(h); });
      },
      handle:   H.bottleAddon,
      mode:     'add',
      headline: 'Shake your sundæys',
      subline:  'Powder dissolves best when shaken. Signature Tritan Bottle – BPA-free, heat-proof, 500ml.',
      price:    '$19',
      priceWas: '$29',
      save:     'Save $10',
      cta:      'Add to order',
      buildDisplay: function () {
        var price = priceCache[H.bottleAddon];
        var was   = priceCache[H.bottle];
        if (!price) return {};
        var out = { price: fmt(price) };
        if (was) {
          out.priceWas = fmt(was);
          if (was > price) out.save = 'Save ' + fmt(was - price);
        }
        return out;
      },
    },

    /* Rule 2: Capsules single → upgrade to The Standard */
    {
      id:         'capsules-single-upgrade',
      check:      function (handles) { return handles.indexOf(H.capsules) !== -1; },
      handle:     H.standard,
      mode:       'replace',
      replaceKey: 'capsules',
      headline:   'Want the full kit?',
      subline:    '2\xD7 Capsules + 1\xD7 Powder + free Bottle + surprise gift.',
      price:      '$139',
      cta:        'Upgrade to The Standard',
      buildDisplay: function () {
        var price = priceCache[H.standard];
        if (!price) return {};
        return { price: fmt(price) };
      },
    },

    /* Rule 3: Capsules Duo → upgrade to The Standard */
    {
      id:         'capsules-duo-upgrade',
      check:      function (handles) { return handles.indexOf(H.capsulesDuo) !== -1; },
      handle:     H.standard,
      mode:       'replace',
      replaceKey: 'capsulesDuo',
      headline:   'Upgrade for just $40 more',
      subline:    'Add Powder ($49), Signature Bottle ($29), and surprise gift.',
      price:      '$139',
      priceWas:   '$97 in extras',
      save:       'included',
      cta:        'Upgrade to The Standard',
      buildDisplay: function () {
        var target = priceCache[H.standard];
        var from   = priceCache[H.capsulesDuo];
        var powder = priceCache[H.powder];
        var bottle = priceCache[H.bottle];
        if (!target) return {};
        var out = { price: fmt(target) };
        if (from && target > from) {
          out.headline = 'Upgrade for just ' + fmt(target - from) + ' more';
        }
        if (powder && bottle) {
          out.priceWas = fmt(powder + bottle) + ' in extras';
          out.subline  = 'Add Powder (' + fmt(powder) + '), Signature Bottle (' + fmt(bottle) + '), and surprise gift.';
        }
        return out;
      },
    },

    /* Rule 4: Capsules Trio → upgrade to The Supply */
    {
      id:         'capsules-trio-upgrade',
      check:      function (handles) { return handles.indexOf(H.capsulesTrio) !== -1; },
      handle:     H.supply,
      mode:       'replace',
      replaceKey: 'capsulesTrio',
      headline:   'Go all in for just $50 more',
      subline:    'Add 2\xD7 Powder ($98), Signature Bottle ($29), and surprise gift.',
      price:      '$179',
      priceWas:   '$127 in extras',
      save:       'included',
      cta:        'Upgrade to The Supply',
      buildDisplay: function () {
        var target = priceCache[H.supply];
        var from   = priceCache[H.capsulesTrio];
        var powder = priceCache[H.powder];
        var bottle = priceCache[H.bottle];
        if (!target) return {};
        var out = { price: fmt(target) };
        if (from && target > from) {
          out.headline = 'Go all in for just ' + fmt(target - from) + ' more';
        }
        if (powder && bottle) {
          out.priceWas = fmt(powder * 2 + bottle) + ' in extras';
          out.subline  = 'Add 2\xD7 Powder (' + fmt(powder * 2) + '), Signature Bottle (' + fmt(bottle) + '), and surprise gift.';
        }
        return out;
      },
    },

    /* Rule 5: The Pair → upgrade to The Standard */
    {
      id:         'pair-upgrade',
      check:      function (handles) { return handles.indexOf(H.pair) !== -1; },
      handle:     H.standard,
      mode:       'replace',
      replaceKey: 'pair',
      headline:   'Want the full kit for only $50 more?',
      subline:    '2\xD7 Capsules + 1\xD7 Powder + free Bottle + surprise gift.',
      price:      '$139',
      cta:        'Upgrade to The Standard',
      buildDisplay: function () {
        var target = priceCache[H.standard];
        var from   = priceCache[H.pair];
        if (!target) return {};
        var out = { price: fmt(target) };
        if (from && target > from) {
          out.headline = 'Want the full kit for only ' + fmt(target - from) + ' more?';
        }
        return out;
      },
    },

    /* Rule 6: The Standard → upgrade to The Supply */
    {
      id:         'standard-upgrade',
      check:      function (handles) { return handles.indexOf(H.standard) !== -1; },
      handle:     H.supply,
      mode:       'replace',
      replaceKey: 'standard',
      headline:   'Save 26% per evening',
      subline:    '3\xD7 Capsules + 2\xD7 Powder + Bottle. Enough for weeks – just $40 more.',
      price:      '$179',
      cta:        'Upgrade to The Supply',
      buildDisplay: function () {
        var target = priceCache[H.supply];
        var from   = priceCache[H.standard];
        if (!target) return {};
        var out = { price: fmt(target) };
        if (from && target > from) {
          out.subline = '3\xD7 Capsules + 2\xD7 Powder + Bottle. Enough for weeks – just ' + fmt(target - from) + ' more.';
        }
        return out;
      },
    },
  ];

  /* ── Session dismiss ───────────────────────────────────────────── */
  var DISMISS_KEY = 's-upsell-dismiss-';
  function isDismissed(id)  { return sessionStorage.getItem(DISMISS_KEY + id) === '1'; }
  function setDismissed(id) { sessionStorage.setItem(DISMISS_KEY + id, '1'); }

  /* ── Rule evaluation ───────────────────────────────────────────── */
  function evaluate(items) {
    if (!items || !items.length) return null;

    var handles = items.map(function (i) { return i.handle; });

    if (handles.some(function (h) { return SUPPRESS_ALL.has(h); })) return null;
    if (!handles.some(function (h) { return SUPPLEMENTS.has(h); })) return null;

    var itemMap = {};
    items.forEach(function (i) { itemMap[i.handle] = i; });

    for (var i = 0; i < RULES.length; i++) {
      var rule = RULES[i];
      if (isDismissed(rule.id)) continue;
      if (!rule.check(handles)) continue;

      var replaceItemKey = null;
      if (rule.mode === 'replace' && rule.replaceKey) {
        var replacedItem = itemMap[H[rule.replaceKey]];
        replaceItemKey = replacedItem ? replacedItem.key : null;
      }

      var display = typeof rule.buildDisplay === 'function' ? rule.buildDisplay() : {};

      return {
        id:             rule.id,
        handle:         rule.handle,
        mode:           rule.mode,
        headline:       display.headline !== undefined ? display.headline : rule.headline,
        subline:        display.subline  !== undefined ? display.subline  : rule.subline,
        price:          display.price    !== undefined ? display.price    : rule.price,
        priceWas:       display.priceWas !== undefined ? display.priceWas : (rule.priceWas  || null),
        save:           display.save     !== undefined ? display.save     : (rule.save      || null),
        cta:            rule.cta,
        replaceItemKey: replaceItemKey,
      };
    }
    return null;
  }

  /* ── Build price row HTML ──────────────────────────────────────── */
  function buildPriceHtml(rule) {
    var html = '';
    if (rule.priceWas) {
      html += '<s class="s-upsell__was">' + rule.priceWas + '</s>';
    }
    html += '<span class="s-upsell__price">' + rule.price + '</span>';
    if (rule.save) {
      html += '<span class="s-upsell__save">' + rule.save + '</span>';
    }
    return html;
  }

  /* ── Render ────────────────────────────────────────────────────── */
  function render(items) {
    var existing = document.querySelector('.s-upsell');
    if (existing) existing.remove();

    var anchor = document.querySelector('.cart__ctas');
    if (!anchor) return;

    var rule = evaluate(items);
    if (!rule) return;

    var el = document.createElement('div');
    el.className = 's-upsell';
    el.dataset.ruleId = rule.id;
    el.innerHTML =
      '<button type="button" class="s-upsell__close" aria-label="Dismiss suggestion">\xD7</button>' +
      '<div class="s-upsell__inner">' +
        '<div class="s-upsell__img" aria-hidden="true"></div>' +
        '<div class="s-upsell__body">' +
          '<p class="s-upsell__headline">' + rule.headline + '</p>' +
          '<p class="s-upsell__subline">' + rule.subline + '</p>' +
          '<div class="s-upsell__footer">' +
            '<div class="s-upsell__price-row">' + buildPriceHtml(rule) + '</div>' +
            '<button type="button" class="s-upsell__cta">' + rule.cta + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';

    anchor.insertAdjacentElement('beforebegin', el);

    el.querySelector('.s-upsell__cta').addEventListener('click', function () {
      handleCta(rule, el);
    });
    el.querySelector('.s-upsell__close').addEventListener('click', function () {
      setDismissed(rule.id);
      el.remove();
    });
  }

  /* ── Drawer refresh helper ─────────────────────────────────────── */
  var _rendering = false;

  function refreshDrawer() {
    return Promise.all([
      fetch('/cart.js').then(function (r) { return r.json(); }),
      fetch('/?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }),
    ]).then(function (results) {
      var cartData     = results[0];
      var sectionsData = results[1];
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        _rendering = true;
        drawer.renderContents({ id: String(cartData.token || ''), sections: sectionsData });
        setTimeout(function () { _rendering = false; }, 0);
      }
      requestAnimationFrame(function () {
        render(cartData.items || []);
        attachInnerObserver();
      });
    });
  }

  /* ── Add / replace ─────────────────────────────────────────────── */
  function handleCta(rule, el) {
    var cta = el.querySelector('.s-upsell__cta');
    var originalLabel = cta ? cta.textContent : '';
    if (cta) { cta.textContent = '…'; cta.disabled = true; }

    fetch('/products/' + rule.handle + '.js')
      .then(function (r) {
        if (!r.ok) throw new Error('product fetch failed: ' + rule.handle);
        return r.json();
      })
      .then(function (product) {
        var newVid = product.variants && product.variants[0] && product.variants[0].id;
        if (!newVid) throw new Error('no variant found for ' + rule.handle);

        return fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ items: [{ id: newVid, quantity: 1 }] }),
        }).then(function (r) {
          if (!r.ok) throw new Error('add to cart failed');
          if (rule.mode === 'replace' && rule.replaceItemKey) {
            return fetch('/cart/change.js', {
              method:  'POST',
              headers: { 'Content-Type': 'application/json' },
              body:    JSON.stringify({ id: rule.replaceItemKey, quantity: 0 }),
            }).then(function (r) {
              if (!r.ok) throw new Error('remove old item failed');
            });
          }
        });
      })
      .then(function () { return refreshDrawer(); })
      .catch(function (err) {
        console.warn('[s-upsell]', err);
        if (cta) { cta.textContent = originalLabel; cta.disabled = false; }
      });
  }

  /* ── Cart fetch + render ───────────────────────────────────────── */
  var _checkTimer = null;

  function checkCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (data) { render(data.items || []); })
      .catch(function (e) { console.warn('[s-upsell]', e); });
  }

  /* ── MutationObserver helpers ──────────────────────────────────── */
  var _innerObserver = null;

  function attachInnerObserver() {
    if (_innerObserver) _innerObserver.disconnect();
    var inner = document.querySelector('.drawer__inner');
    if (!inner) return;
    _innerObserver = new MutationObserver(function () {
      if (_rendering) return;
      clearTimeout(_checkTimer);
      _checkTimer = setTimeout(checkCart, 80);
    });
    _innerObserver.observe(inner, { childList: true });
  }

  /* ── Init ──────────────────────────────────────────────────────── */
  function init() {
    prefetchPrices();

    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    var wasActive = false;
    new MutationObserver(function () {
      var isActive = drawer.classList.contains('active');
      if (isActive && !wasActive) {
        checkCart();
        attachInnerObserver();
      }
      wasActive = isActive;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

    var cartEl = document.getElementById('CartDrawer');
    if (cartEl) {
      new MutationObserver(function () {
        if (_rendering) return;
        attachInnerObserver();
        clearTimeout(_checkTimer);
        _checkTimer = setTimeout(checkCart, 80);
      }).observe(cartEl, { childList: true });
    }

    attachInnerObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

}());
